import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'contract-search-dialog',
    templateUrl: './contract-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class ContractSearchDialogComponent extends SearchDialogComponent {
    consumerModel: any = {};
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Contract';
        this.model.title = 'Select Contract';

        this.model.criteria.Max = this.model.currentOptions.maxRows;

        this.model.criteria.json = 'CT2';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }

    setConsumer(data) {
        let consumer = data[0];

        this.consumerModel.consumerID = consumer.Entity_ID;
        this.consumerModel.consumerName = consumer.Entity_Name;
        this.dsCollection.criteria.Consumer = consumer.Entity_ID;
    }

    clearConsumer() {
        this.consumerModel = {};
        this.dsCollection.criteria.Consumer = '';
    }
}
